import { useContext, useState } from 'react';
import { Api } from '@sodamnfoolish/sjc-backend-types';

import * as Virtual from '../../Components/VirtualGrid/VirtualGrid';
import { createPumpFunTokensSorter } from '../../utils/bubbles/sort';
import PumpFunIcon from '../../Components/assets/PumpFunIcon.png';

import { LiveDataPumpfunToken } from './LiveDataToken';
import { PumpFunLinkedContext } from './context/LinkedContext';
import { DexFeedColumn } from './DexFeedColumn';
import { PumpFunBubblesContext } from './context/PumpFunBubblesContext';
import { isPumpFunSoundMuted } from './localStorage';
import { AppMode } from '../../types';
import { BN } from '@coral-xyz/anchor';
import { calculateBondingCurveProgress } from '../../pumpfun/calc';

const sort = [
    {
        key: 'bonding',
        value: 'Bonding %',
        ASC: createPumpFunTokensSorter('virtualTokenReserves', 'ASC', calculateBondingCurveProgress),
        DESC: createPumpFunTokensSorter('virtualTokenReserves', 'DESC', calculateBondingCurveProgress),
    },
    {
        key: 'creationTime',
        value: 'Creation time',
        ASC: createPumpFunTokensSorter('deployBlockTime', 'ASC', Number),
        DESC: createPumpFunTokensSorter('deployBlockTime', 'DESC', Number),
    },
];

export const PumpFunColumn = Virtual.createColumn<{
    mode: AppMode;
    onCreate: (token: Api.Pump.DTO.PumpFunToken) => void;
    onBuy: (token: Api.Pump.DTO.PumpFunToken, solAmount: BN) => void;
}>(({ id, width, mode, onCreate, onBuy }) => {
    const [store, remove] = useContext(PumpFunBubblesContext);

    return (
        <DexFeedColumn<Api.Pump.DTO.PumpFunToken>
            id={id}
            width={width}
            mode={mode}
            dexName='PumpFun'
            dexIcon={<img className='size-[28px]' src={PumpFunIcon} alt='Pump Fun Icon' />}
            bubbleContainerClassname='bg-[linear-gradient(to_bottom,var(--color-forest-deep),var(--color-dark-ember))]'
            store={store}
            sortItems={sort}
            defaultMuted={isPumpFunSoundMuted()}
            defaultMinLinkedTokens={parseInt(localStorage.getItem('pumpMinLinkedTokens') ?? '3')}
            onCreate={onCreate}
            onBuy={onBuy}
            onRemove={remove}
            onMinTokensChange={(min) => {
                localStorage.setItem('pumpMinLinkedTokens', String(min));
            }}
            onVolumeToggle={(muted) => {
                localStorage.setItem(isPumpFunSoundMuted.key, String(!muted));
            }}
            LiveDataToken={LiveDataPumpfunToken}
            LinkedCtx={PumpFunLinkedContext}
        />
    );
});
